import I18n from 'I18n';
export const ONCE = 'ONCE';
export const DAILY = 'DAILY';
export const WEEKLY = 'WEEKLY';
export const MONTHLY = 'MONTHLY';
export const YEARLY = 'YEARLY';
export const CadenceValues = {
  ONCE,
  DAILY,
  WEEKLY,
  MONTHLY,
  YEARLY
};
export const CadenceTranslationKeys = {
  [ONCE]: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleCadence.once',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.onceDescription_jsx',
    beforeSpecificTimeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.before.onceDescription_jsx',
    afterSpecificTimeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.after.onceDescription_jsx'
  },
  [DAILY]: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleCadence.daily',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.dailyDescription.specificTime_jsx',
    timeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.dailyDescription.timeRange_jsx'
  },
  [WEEKLY]: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleCadence.weekly',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.weeklyDescription.specificTime_jsx',
    timeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.weeklyDescription.timeRange_jsx'
  },
  [MONTHLY]: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleCadence.monthly',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.monthlyDescription.specificTime_jsx',
    timeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.monthlyDescription.timeRange_jsx'
  },
  [YEARLY]: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleCadence.yearly',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.yearlyDescription.specificTime_jsx',
    timeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.yearlyDescription.timeRange_jsx',
    beforeSpecificTimeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.before.yearlyDescription.specificTime_jsx',
    afterSpecificTimeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.after.yearlyDescription.specificTime_jsx',
    beforeTimeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.before.yearlyDescription.timeRange_jsx',
    afterTimeRangeDescriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleLabel.after.yearlyDescription.timeRange_jsx'
  }
};
const getFormattedTime = ({
  hours,
  minutes,
  showTimeZone
}) => {
  const timeFormatWithZone = showTimeZone ? `LT [${I18n.moment.portalTz().format('z')}]` : `LT`;
  return I18n.moment().hours(hours).minutes(minutes !== null && minutes !== void 0 ? minutes : 0).format(timeFormatWithZone);
};
export const ScheduleWidowTimeRanges = {
  BEFORE_BUSINESS_HOURS: {
    start: 0,
    end: 10
  },
  DURING_BUSINESS_HOURS: {
    start: 10,
    end: 17
  },
  AFTER_BUSINESS_HOURS: {
    start: 17,
    end: 24
  }
};
export const ScheduleWindowTranslationKeys = {
  SPECIFIC_TIME: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.SPECIFIC_TIME'
  },
  BEFORE_BUSINESS_HOURS: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.BEFORE_BUSINESS_HOURS',
    getDisplayText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.displayTimeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.BEFORE_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.BEFORE_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    },
    getHelpText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.timeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.BEFORE_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.BEFORE_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    }
  },
  DURING_BUSINESS_HOURS: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.DURING_BUSINESS_HOURS',
    getDisplayText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.displayTimeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.DURING_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.DURING_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    },
    getHelpText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.timeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.DURING_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.DURING_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    }
  },
  AFTER_BUSINESS_HOURS: {
    titleKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.AFTER_BUSINESS_HOURS',
    getDisplayText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.displayTimeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.AFTER_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.AFTER_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    },
    getHelpText: ({
      showTimeZone = true
    } = {}) => {
      return I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.timeRange', {
        startTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.AFTER_BUSINESS_HOURS.start,
          showTimeZone
        }),
        endTime: getFormattedTime({
          hours: ScheduleWidowTimeRanges.AFTER_BUSINESS_HOURS.end,
          showTimeZone
        })
      });
    }
  }
};